import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_BALANCE_SERVER } from '@/app/module/payments/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { useRequirePermission } from '@/app/module/user/store/ts/hooks'
import { hasTotpError } from '@/app/service/util/error'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetBalance = () => {
  const dispatch = useAppDispatch()
  const canGetBalance = useRequirePermission('getBalance')
  const orgId = useSelector(selectOrgId)

  const skip = !orgId || !canGetBalance // orgId can be 0 when the user has no org at all.
  const res = esApi.endpoints.getOrgBalance.useQuery({ orgId: orgId.toString() }, { skip })

  useEffect(() => {
    if (!res.error || hasTotpError(res.error)) {
      return
    }
    dispatch(
      createNotification({
        'get-balance': {
          type: 'error',
          message: ERROR_GET_BALANCE_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
